// extracted by mini-css-extract-plugin
module.exports = {"Ul_horizontal":"navigation_items_Ul_horizontal__2eF6y","Ul_vertical":"navigation_items_Ul_vertical__23MoT"};